import type { builderObject } from '../../../../shared';
import type { NavigationState, ClickedHubPersonaState } from '../../../state/view/navigationState';
import {
    searchSuggestedPersonaClickedAction,
    searchResultResetAction,
    searchModeExitClickAction,
} from '../../../../searchbox';

export default (reducer: builderObject<NavigationState>): builderObject<NavigationState> =>
    reducer
        .handle(searchSuggestedPersonaClickedAction, (state, action) => {
            const clickedHubPersona: ClickedHubPersonaState = {
                hubPersonaId: action.payload.hubPersonaId,
                origin: 'searchSuggestion',
            };

            return {
                ...state,
                currentQuery: { queryText: undefined, hubPersonaId: action.payload.hubPersonaId },
                clickedHubPersona: clickedHubPersona,
                lastClickedHubPersonaBeforeEVNavigation: clickedHubPersona,
                currentRoute: '',
                personaListCheckedHubPersonaDetails: [],
            };
        })
        .handle(searchResultResetAction, (state, action) => {
            return {
                ...state,
                currentQuery: {
                    queryText: action.payload.searchQuery,
                    hubPersonaId: undefined,
                    folderId: action.payload.folderId,
                },
                clickedHubPersona: undefined,
                personaListCheckedHubPersonaDetails: [],
            };
        })
        .handle(searchModeExitClickAction, state => {
            return {
                ...state,
                currentQuery: undefined,
                clickedHubPersona: undefined,
                lastClickedHubPersonaBeforeEVNavigation: undefined,
                personaListCheckedHubPersonaDetails: [],
            };
        });
